<script>import { createEventDispatcher, onDestroy } from "svelte";
import { baseUrl, transformationsPreset, onErrorPlaceholder, noImagePlaceholder } from "../config/configuration";
import { POOL_TIMEOUT } from "../config/constants";
import { cn } from "../tools/cn";
import { parsePictureSizes } from "../libs/parse-picture-sizes.js";
import { getSources } from "../libs/get-sources.js";
import { getSrc } from "../libs/get-src.js";
import { getPlaceholder } from "../libs/get-placeholder";
import { isImageSvg } from "../libs/is-image-svg.js";
import Picture from "./picture.svelte";
import { joinPath } from "../tools/join-path";
const dispatch = createEventDispatcher();
export let imageData;
export let pictureSizes;
export let presetKeys;
export let onErrorPlaceholderStatic = void 0;
export let noImagePlaceholderStatic = void 0;
export let imgClasses = "";
export let placeholderClasses = "";
export let alt;
export let loading = "eager";
export let attributes = {};
export let imgElement = void 0;
$:
  imageFilename = imageData?.filename_disk || "";
$:
  assetTransformations = imageData?.asset_transformations || [];
$:
  width = imageData?.width || 0;
$:
  height = imageData?.height || 0;
$:
  isSvg = isImageSvg(imageFilename);
$:
  parsedPictureSizes = isSvg ? "" : parsePictureSizes(pictureSizes);
$:
  pictureSources = isSvg ? [] : getSources(presetKeys, assetTransformations, transformationsPreset, baseUrl);
$:
  imageSrc = isSvg ? joinPath(baseUrl, imageFilename) : getSrc(imageData);
let isErrored = false;
let pool = false;
let poolTimerId;
function onError(e) {
  isErrored = true;
  pool = false;
  poolTimerId = setTimeout(() => pool = true, POOL_TIMEOUT);
  dispatch("error", e.detail);
}
function onPoolLoad() {
  pool = false;
  isErrored = false;
  clearTimeout(poolTimerId);
}
onDestroy(() => {
  clearTimeout(poolTimerId);
});
function choosePlaceholderStatic(onErrorPlaceholderStatic2, placeholder) {
  return onErrorPlaceholderStatic2 || placeholder;
}
function poolIfProcessing(currentImageSrc, imageFilename2) {
  if (!imageFilename2 || isSvg) {
    return;
  }
  if (currentImageSrc === joinPath(baseUrl, imageFilename2)) {
    isErrored = true;
    pool = true;
  }
}
$:
  poolIfProcessing(imageSrc, imageFilename);
</script>

{#if !imageFilename || isErrored}
  {@const placeholder = getPlaceholder(imageData, isErrored, {
    noImagePlaceholder,
    noImagePlaceholderStatic,
    onErrorPlaceholder,
    onErrorPlaceholderStatic,
  })}
  {#if $$slots['no-image-placeholder'] && !imageFilename}
    <slot name="no-image-placeholder" />
  {:else if $$slots['on-error-placeholder'] && isErrored}
    <slot name="on-error-placeholder" />
  {:else if $$slots['default-placeholder']}
    <slot name="default-placeholder" />
  {:else if placeholder.object && 'Component' in placeholder.object}
    {@const PlaceholderComponent = placeholder.object.Component}
    <PlaceholderComponent />
  {:else if placeholder.object || placeholder.static}
    {@const currentPlaceholder = choosePlaceholderStatic(placeholder.static, placeholder.object)}
    <img
      src="{currentPlaceholder.src}"
      width="{currentPlaceholder.width}"
      height="{currentPlaceholder.height}"
      alt="placeholder"
      class="{cn(imgClasses, placeholderClasses)}"
    />
  {/if}
{:else if imageFilename}
  <Picture
    {imageSrc}
    imageWidth="{width}"
    imageHeight="{height}"
    pictureSizes="{parsedPictureSizes}"
    {pictureSources}
    {imgClasses}
    bind:imgElement
    {alt}
    {loading}
    {attributes}
    on:error="{onError}"
    on:load
  />
{/if}

{#if isErrored && pool && imageFilename}
  <div class="pool">
    <Picture
      {imageSrc}
      {pictureSources}
      pictureSizes="{parsedPictureSizes}"
      alt=""
      on:load="{onPoolLoad}"
      on:error="{onError}"
    />
  </div>
{/if}

<style>
  .pool {
    width: 0;
    height: 0;
    position: fixed;
    opacity: 0;
    pointer-events: none;
  }
</style>
